import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import InstalmentConditoin from "./InstalmentConditoin"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionInstalmentDate = [
      { value: "0", label: "نقد" },
      { value: "1", label: "یک ماه بعد" },
      { value: "2", label: "دو ماه بعد" },
      { value: "3", label: "سه ماه بعد" },
      { value: "4", label: "چهار ماه بعد" },
      { value: "5", label: "پنج ماه بعد" },
      { value: "6", label: "شش ماه بعد" },
      { value: "7", label: "هفت ماه بعد" },
      { value: "8", label: "هشت ماه بعد" },
      { value: "9", label: "نه ماه بعد" },
      { value: "10", label: "ده ماه بعد" },
      { value: "11", label: "یازده ماه بعد" },
]

class ChangeInstalment extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  instalment_id: "",
                  instalment_numround: "",
                  instalment_desc: "",
                  instalment_date_start: "",
                  instalment_date_end: "",
                  selectedFieldinsurance: "",
                  selectedFilterFieldinsurance: "",
                  selectedInstamentRoundMode: "",
                  selectedCompany: "",
                  selectedFilterCompany: "",
                  instalment_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  orderBy: "instalment_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newInstalment: true,
                  optionInstamentRoundMode: [],
                  optionInstalmentMode: [],
                  optionCompany: [],
                  optionFilterCompany: [],
                  optionFieldinsurance: [],
                  optionFilterFieldinsurance: [],
                  openDialog: false,
                  installmentCondition: [],
                  instalment_conditions_percent: "",
                  instalment_conditions_desc: "",
                  selectedInstalmentDate: "",
                  selectedInstalmentMode: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeNumRound = (event) => {
            this.setState({ instalment_numround: event.target.value })
      }

      handleChangeDesc = (event) => {
            this.setState({ instalment_desc: event.target.value })
      }

      setSelectedDayStart = (event) => {
            this.setState({ instalment_date_start: event }, () => {})
      }

      setSelectedDayEnd = (event) => {
            console.log(event)
            this.setState({ instalment_date_end: event }, () => {})
      }

      clearDeyStart = (event) => {
            this.setState({ instalment_date_start: "" }, () => {})
      }
      clearDeyEnd = (event) => {
            this.setState({ instalment_date_end: "" }, () => {})
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance, fieldinsurance_logo_url: selectedFieldinsurance.logo })
      }

      handleInstamentRoundMode = (selectedInstamentRoundMode) => {
            this.setState({ selectedInstamentRoundMode: selectedInstamentRoundMode })
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterInstalment()
            })
      }
      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, company_logo_url: selectedCompany.logo })
      }

      handleFilterCompany = (selectedFilterCompany) => {
            this.setState({ selectedFilterCompany: selectedFilterCompany }, () => {
                  this.filterInstalment()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ instalment_deactive: "0" })
            } else {
                  this.setState({ instalment_deactive: "1" })
            }
      }

      handleInstalmentMode = (selectedInstalmentMode) => {
            this.setState({ selectedInstalmentMode: selectedInstalmentMode })
      }

      handleInstalmentDate = (selectedInstalmentDate) => {
            this.setState({ selectedInstalmentDate: selectedInstalmentDate })
      }
      handleChangeConditionsPercent = (event) => {
            this.setState({ instalment_conditions_percent: event.target.value })
      }

      handleChangeConditionsDesc = (event) => {
            this.setState({ instalment_conditions_desc: event.target.value })
      }

      handleSelectRows = (row2) => {
            var jdate1 = "",
                  jdate2 = ""
            if (row2.instalment_date_start !== "") {
                  var varmoment1 = Moment(row2.instalment_date_start, "YYYY-M-D HH:mm:ss")
                  var date1 = new Date(parseInt(varmoment1.format("x")))
                  jdate1 = new JDate(date1)
                  jdate1 = { day: parseInt(jdate1.format("DD")), month: parseInt(jdate1.format("MM")), year: parseInt(jdate1.format("YYYY")) }
            }
            if (row2.instalment_date_end !== "") {
                  var varmoment2 = Moment(row2.instalment_date_end, "YYYY-M-D HH:mm:ss")
                  var date2 = new Date(parseInt(varmoment2.format("x")))
                   jdate2 = new JDate(date2)
                  jdate2 = { day: parseInt(jdate2.format("DD")), month: parseInt(jdate2.format("MM")), year: parseInt(jdate2.format("YYYY")) }
            }

            this.getInstalmentCondition(row2.instalment_id)
            this.setState(
                  {
                        instalment_id: row2.instalment_id,
                        instalment_desc: row2.instalment_desc,
                        instalment_numround: row2.instalment_numround,
                        instalment_date_start: jdate1,
                        instalment_date_end: jdate2,
                        selectedFieldinsurance: {
                              value: row2.instalment_fieldinsurance_id,
                              label: row2.fieldinsurance_fa,
                              logo: row2.fieldinsurance_logo_url,
                        },
                        selectedCompany: { value: row2.instalment_company_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedInstamentRoundMode: { value: row2.instalment_round_id, label: row2.instalment_round_name },

                        instalment_deactive: row2.instalment_deactive,
                        company_logo_url: row2.company_logo_url,
                        fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                        newInstalment: false,
                  },
                  () => {}
            )
      }

      newInstalment = (event) => {
            this.setState({
                  instalment_id: "",
                  instalment_numround: "",
                  instalment_desc: "",
                  instalment_date_start: "",
                  instalment_date_end: "",
                  selectedFieldinsurance: "",
                  selectedCompany: "",
                  selectedInstamentRoundMode: "",
                  instalment_deactive: "0",
                  company_logo_url: "",
                  fieldinsurance_logo_url: "",
                  newInstalment: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getInstalment()
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                                    self.getoptionInstalmentMode()
                                    self.getoptionInstamentRoundMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { instalment_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getInstalment()
                              self.newInstalment()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_instalment")
            fd.append("instalment_id", instalment_id)

            xhttp.open("POST", `${constants.BASE_URL}/instalment`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getInstalment() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment")

            xhttp.open("POST", `${constants.BASE_URL}/instalment`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getInstalmentCondition(instalment_id) {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ installmentCondition: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_conditions")
            fd.append("instalment_id", instalment_id)

            xhttp.open("POST", `${constants.BASE_URL}/instalment`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionInstalmentMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_mode_mode_id, label: arr.data[k].instalment_mode_mode_name })
                              }
                              self.setState({ optionInstalmentMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionInstamentRoundMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].instalment_round_id, label: arr.data[k].instalment_round_name })
                              }
                              self.setState({ optionInstamentRoundMode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_instalment_mode_round")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه شرکت های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, optionFilterCompany: Company1, selectedFilterCompany: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState(
                                    {
                                          optionFieldinsurance: Company,
                                          optionFilterFieldinsurance: Company1,
                                          selectedFilterFieldinsurance: Company1[0],
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      saveNewInstalment = () => {
            const {
                  instalment_numround,
                  instalment_desc,
                  selectedInstamentRoundMode,
                  instalment_date_start,
                  instalment_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  instalment_deactive,
            } = this.state
            if (selectedInstamentRoundMode != "" && selectedFieldinsurance != "" && selectedCompany != "" && instalment_desc != ""&& instalment_numround != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getInstalment()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_instalment")
                  fd.append("instalment_numround", instalment_numround)
                  fd.append("instalment_desc", instalment_desc)
                  if (instalment_date_start === "") {
                        fd.append("instalment_date_start", "")
                  } else {
                        fd.append(
                              "instalment_date_start",
                              Moment(JDate.toGregorian(instalment_date_start.year, instalment_date_start.month, instalment_date_start.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  if (instalment_date_end === "") {
                        fd.append("instalment_date_end", "")
                  } else {
                        fd.append(
                              "instalment_date_end",
                              Moment(JDate.toGregorian(instalment_date_end.year, instalment_date_end.month, instalment_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("instalment_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("instalment_company_id", selectedCompany.value)
                  fd.append("instalment_round_id", selectedInstamentRoundMode.value)
                  fd.append("instalment_deactive", instalment_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/instalment`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewInstalmentCondition = () => {
            const {
                  instalment_id,
                  selectedInstalmentDate,
                  selectedInstalmentMode,
                  instalment_conditions_percent,
                  instalment_conditions_desc,
            } = this.state
            if (
                  selectedInstalmentDate != "" &&
                  selectedInstalmentMode != "" &&
                  instalment_conditions_percent != "" &&
                  instalment_conditions_desc != ""
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          instalment_conditions_percent: "",
                                          instalment_conditions_desc: "",
                                          selectedInstalmentDate: "",
                                          selectedInstalmentMode: "",
                                    })
                                    self.getInstalmentCondition(instalment_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_instalment_conditions")
                  fd.append("instalment_conditions_instalment_id", instalment_id)
                  fd.append("instalment_conditions_percent", instalment_conditions_percent)
                  fd.append("instalment_conditions_desc", instalment_conditions_desc)
                  fd.append("instalment_conditions_date", selectedInstalmentDate.value)
                  fd.append("instalment_conditions_mode_id", selectedInstalmentMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/instalment`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeInstalment = () => {
            const {
                  selectedInstamentRoundMode,
                  instalment_id,
                  instalment_numround,
                  instalment_desc,
                  instalment_date_start,
                  instalment_date_end,
                  selectedFieldinsurance,
                  selectedCompany,
                  instalment_deactive,
            } = this.state
            if (selectedInstamentRoundMode != "" && selectedFieldinsurance != "" && selectedCompany != "" && instalment_desc != ""&& instalment_numround != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getInstalment()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_instalment")
                  fd.append("instalment_id", instalment_id)
                  fd.append("instalment_numround", instalment_numround)
                  fd.append("instalment_desc", instalment_desc)

                  if (instalment_date_start === "") {
                        fd.append("instalment_date_start", "")
                  } else {
                        fd.append(
                              "instalment_date_start",
                              Moment(JDate.toGregorian(instalment_date_start.year, instalment_date_start.month, instalment_date_start.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  if (instalment_date_end === "") {
                        fd.append("instalment_date_end", "")
                  } else {
                        fd.append(
                              "instalment_date_end",
                              Moment(JDate.toGregorian(instalment_date_end.year, instalment_date_end.month, instalment_date_end.day)).format(
                                    "YYYY-MM-DD h:mm:ss"
                              )
                        )
                  }
                  fd.append("instalment_round_id", selectedInstamentRoundMode.value)
                  fd.append("instalment_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("instalment_company_id", selectedCompany.value)
                  fd.append("instalment_deactive", instalment_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/instalment`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterInstalment = () => {
            const { selectedFilterFieldinsurance, selectedFilterCompany, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterCompany.value === 0 || temparray[i].instalment_company_id === selectedFilterCompany.value) &&
                        (selectedFilterFieldinsurance.value === 0 || temparray[i].instalment_fieldinsurance_id === selectedFilterFieldinsurance.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.instalment_date_end.year
                              ? this.state.instalment_date_end.year +
                                "/" +
                                this.state.instalment_date_end.month +
                                "/" +
                                this.state.instalment_date_end.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.instalment_date_start.year
                              ? this.state.instalment_date_start.year +
                                "/" +
                                this.state.instalment_date_start.month +
                                "/" +
                                this.state.instalment_date_start.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  selectedInstamentRoundMode,
                  optionInstamentRoundMode,
                  optionInstalmentMode,
                  instalment_conditions_percent,
                  instalment_conditions_desc,
                  selectedInstalmentDate,
                  selectedInstalmentMode,
                  optionCompany,
                  installmentCondition,
                  optionFilterCompany,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newInstalment,
                  instalment_id,
                  instalment_numround,
                  instalment_desc,
                  instalment_date_start,
                  instalment_date_end,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  company_logo_url,
                  fieldinsurance_logo_url,
                  selectedCompany,
                  selectedFilterCompany,
                  instalment_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره شرایط اقساط: " + instalment_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt="Remy Sharp"
                                                                              className={classes.large}
                                                                              src={fieldinsurance_logo_url}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" className={classes.large} src={company_logo_url} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleFieldinsurance}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={instalment_date_start}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ پایان  "}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={instalment_date_end}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on"> نوع محاسبه اقساط</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع محاسیه اقساط"}
                                                                              value={selectedInstamentRoundMode}
                                                                              onChange={this.handleInstamentRoundMode}
                                                                              options={optionInstamentRoundMode}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="تعداد ارقام رند کردن"
                                                                        handleInputt={this.handleChangeNumRound}
                                                                        value={instalment_numround}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                      placeholder="توضیحات"
                                                                      handleInputt={this.handleChangeDesc}
                                                                      value={instalment_desc}
                                                                  />
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={instalment_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت  شرایط اقساط"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newInstalment ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewInstalment}>
                                                                              {"ثبت شرایط اقساط جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newInstalment}>
                                                                                    {"شرایط اقساط جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changeInstalment}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف شرایط اقساط"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                            {newInstalment ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                            {newInstalment ? null : (
                                                                  <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                        {installmentCondition.map((condition, index) => (
                                                                              <InstalmentConditoin
                                                                                    condition={condition}
                                                                                    props={this.props}
                                                                                    key={index}
                                                                              />
                                                                        ))}
                                                                  </Grid>
                                                            )}
                                                            {newInstalment ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={6} sm={2}>
                                                                                    <div>
                                                                                          <label className="on"> نوع</label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"نوع اقساط"}
                                                                                                value={selectedInstalmentMode}
                                                                                                onChange={this.handleInstalmentMode}
                                                                                                options={optionInstalmentMode}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>

                                                                              <Grid item xs={6} sm={3}>
                                                                                    <div>
                                                                                          <label className="on"> زمان</label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"زمان"}
                                                                                                value={selectedInstalmentDate}
                                                                                                onChange={this.handleInstalmentDate}
                                                                                                options={optionInstalmentDate}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>

                                                                              <Grid item item xs={3} sm={2}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="درصد"
                                                                                          handleInputt={this.handleChangeConditionsPercent}
                                                                                          value={instalment_conditions_percent}
                                                                                    />
                                                                              </Grid>
                                                                              <Grid item item xs={5} sm={3}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="توضیحات"
                                                                                          handleInputt={this.handleChangeConditionsDesc}
                                                                                          value={instalment_conditions_desc}
                                                                                    />
                                                                              </Grid>

                                                                              <Grid item item xs={4} sm={2}>
                                                                                    <div style={{ width: "100%", textAlign: "left" }}>
                                                                                          <Fab
                                                                                                color="primary"
                                                                                                aria-label="add"
                                                                                                onClick={this.saveNewInstalmentCondition}
                                                                                          >
                                                                                                <AddIcon />
                                                                                          </Fab>
                                                                                    </div>
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFilterFieldinsurance}
                                                                              onChange={this.handleFilterFieldinsurance}
                                                                              options={optionFilterFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedFilterCompany}
                                                                              onChange={this.handleFilterCompany}
                                                                              options={optionFilterCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"instalment_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "instalment_id" ? order : false}
                                                                              >
                                                                                    {" آی دی تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_id"}
                                                                                          direction={orderBy === "instalment_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" رشته بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_fa"}
                                                                                          direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"instalment_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" تعداد استفاده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_num"}
                                                                                          direction={orderBy === "instalment_num" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"instalment_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت شرایط اقساط"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_deactive"}
                                                                                          direction={
                                                                                                orderBy === "instalment_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["instalment_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"instalment_id"} align={"center"}>
                                                                                                      {row["instalment_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["fieldinsurance_fa"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                      {row["instalment_num"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"instalment_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["instalment_deactive"] === "1" ||
                                                                                                      row["instalment_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید شرایط اقساط را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeInstalment)
